import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { toast } from "react-toastify";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, getMomentFormatter } from "../../utils";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { CndsStore } from "../../stores/cnds/CndsStore";
import { MDBCol, MDBRow } from "mdbreact";
import { DateInput } from "@blueprintjs/datetime";
import moment from "moment";
import MomentLocaleUtils from "react-day-picker/moment";
import IntlCurrencyInput from "react-intl-currency-input";
import { AppStore } from "../../stores/AppStore";
import socket from "../../socket";

const numeral = require("numeral");

@observer
export default class SolicitaCnds extends React.Component<{}, {}> {

  obs = observable({
    listEmpresas: [] as any[],
    recorrente: false as boolean,
    gratuito: false as boolean,
    data: null as Date,

    open_buy_chave: false as boolean,
    credito_restantes: 0 as number,
    quantidade: "" as string,
    valor_total: 0 as number,
    pagamento_pix: false as boolean,

  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
  }

  handleClose() {

    CndsStore.obs.open_solicitar = false

    this.obs.listEmpresas = []
  }

  async handleCreateTask() {

    if (!(this.obs.data)) {

      toast.error("Informe um dia válido!", {});
      return

    }

    if (this.obs.listEmpresas.length == 0) {

      toast.error("Selecione pelo menos uma Empresa!", {});
      return

    }

    let params = {
      recorrente: this.obs.recorrente,
      itens: this.obs.listEmpresas,
      dia: parseInt(moment(this.obs.data).format("DD")),
      mes: parseInt(moment(this.obs.data).format("MM")),
      ano: parseInt(moment(this.obs.data).format("YYYY")),
      gratuito: this.obs.gratuito
    }

    CndsStore.obs.open_solicitar = false
    CndsStore.obs.loading_solicitacao = true

    await CndsStore.handleSolicitaCnds(params)

    this.obs.listEmpresas = []

  }

  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.listEmpresas.push({ cnpj: row.cnpj_default, ie: row.ie });

    } else {

      let index = this.obs.listEmpresas.findIndex(obj => obj.cnpj === row.cnpj_default);

      if (index !== -1) {
        this.obs.listEmpresas.splice(index, 1);
      }

    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.listEmpresas.push({ cnpj: value.cnpj_default, ie: value.ie });

      });

    } else {

      this.obs.listEmpresas = [];
    }

  };

  createCustomSearchField = (props) => {

    return (
      <SearchField
        className="input-filter input-filter-cnds"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );

  };

  handleDateRealizarChange = (val: Date) => {

    if (val == null) {

      return this.obs.data = null

    }

    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (!this.obs.recorrente && date1 < dataAgora) {

      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.obs.data = null

    } else {

      this.obs.data = val

    }

  };

  thisValorCompra() {

    let valor_total = parseInt(this.obs.quantidade) * 0.88

    this.obs.valor_total = valor_total

    return (<>
      <MDBCol md="12">
        <div className="blocoAssin">
          <span className="priceAssinPerfil"><b>R$</b> {numeral(valor_total).format("0,0.00")}</span>
          <span className="descAssinPerfil">Total de chaves {numeral(this.obs.quantidade).format("0,0")}</span>
        </div>
      </MDBCol>
    </>)
  }

  async handleBuyChaves() {
    if (this.obs.quantidade == "") {
      toast.error("Insira uma quantidade!", {});
      return
    }

    if ((parseInt(this.obs.quantidade) * 0.88) < 1) {
      toast.error("O valor mínimo aceito é de R$ 1,00 (um real).", {});
      return
    }

    this.obs.open_buy_chave = false

    let quantidade = parseInt(this.obs.quantidade)

    let status = await CndsStore.handleBuyQuantidade(quantidade)

    if (status) {

      this.handleSocketPaid()
    }

  }

  handleSocketPaid() {
    this.obs.pagamento_pix = true

    let socket_paid = socket.channel("paid:" + AppStore.obs1.contaId);

    socket_paid.join()
      .receive("ok", resp => {
        console.log("Bem vindo 1", resp)
      })
      .receive("error", resp => {
        console.log("Error", resp)
      })

    socket_paid.on("paid", payload => {

      if (payload.body) {
        toast.success('Pagamento recebido com sucesso!');

        CndsStore.handleConsultaCredito()

        socket_paid.off("paid:" + AppStore.obs1.contaId)

        this.obs.pagamento_pix = false

      } else {
        toast.error('Nenhum pagamento encontrato!');

        this.obs.pagamento_pix = false

      }

    })

  }

  handleCancelPix() {
    CndsStore.obs.qrcode = ""
    CndsStore.obs.pix_id = ""
    this.obs.quantidade = ""
    this.obs.pagamento_pix = false
}

  render() {

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.listEmpresas.map(x => x["cnpj"]),
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const options = {
      searchField: this.createCustomSearchField,
    };

    let select_empresas = EmpresaStore.sortedEmpresas.map(map_emp => {

      let emp = EmpresaStore.getByCnpj(map_emp.cnpj);

      if (emp && emp.ativo) {

        return ({
          _id: emp._id,
          razao_social: emp.razao_social,
          ie: emp.inscricao_estadual,
          apelido: emp.apelido,
          cnpj: formatCnpj(emp.cnpj),
          cnpj_default: emp.cnpj
        })

      }

    });

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    const getRestante = () => {

      this.obs.credito_restantes = CndsStore.obs.credito_contratado - CndsStore.obs.credito_usados

      return this.obs.credito_restantes

    }

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    return (
      <>

        <Dialog
          isOpen={CndsStore.obs.open_solicitar}
          onClose={() => this.handleClose()}
          className="modal-cnds"
        >
          {/* <h2 className="titleSEFAZ">Solicitar CNDS</h2> */}
          <MDBRow md="12">
            <MDBCol md="12">
              <MDBRow md="12">
                <MDBCol md="4">
                  <div className="area-status-assuntos restantes">
                    <div style={{ display: "flex", margin: "auto" }}>
                      <div style={{ textAlign: "center", margin: "auto" }}>
                        <img src="/images/adquirido.png" className="pointer hvr-buzz warning-buzz" onClick={() => this.obs.open_buy_chave = true}></img>
                      </div>
                      <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                        <p className="topo-title-xml cnds-credits">{CndsStore.obs.credito_contratado.toLocaleString('pt-BR')}</p>
                        <p className="fundo-title-xml">Total Adquirido</p>
                      </div>
                    </div>
                  </div>
                </MDBCol>
                <MDBCol md="4">
                  <div className="area-status-assuntos usadas" >
                    <div style={{ display: "flex", margin: "auto" }}>
                      <div style={{ textAlign: "center", margin: "auto" }}>
                        <img src="/images/usadas.png"></img>
                      </div>
                      <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                        <p className="topo-title-xml cnds-credits">{CndsStore.obs.credito_usados.toLocaleString('pt-BR')}</p>
                        <p className="fundo-title-xml">Créditos Utilizadas</p>
                      </div>
                    </div>
                  </div>
                </MDBCol>
                <MDBCol md="4">
                  <div className="area-status-assuntos adquiradas">
                    <div style={{ display: "flex", margin: "auto" }}>
                      <div style={{ textAlign: "center", margin: "auto" }}>
                        <img src="/images/restantes.png"></img>
                      </div>
                      <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                        <p className="topo-title-xml cnds-credits">{getRestante().toLocaleString('pt-BR')}</p>
                        <p className="fundo-title-xml">Créditos Restantes</p>
                      </div>
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>

              <p style={{ color: "red" }}>Atenção: Você tem direito a um crédito por empresa mensalmente. Para solicitações adicionais da <b>Certidão de Débitos Relativos a Créditos Tributários Federais e à Dívida Ativa da União</b>, será necessário adquirir créditos extras.</p>

            </MDBCol>

            <MDBCol md="12">
              <div style={{ display: "flex" }}>
                <FormGroup label="Recorrência" />
                &nbsp;
                &nbsp;
                <Switch
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  checked={this.obs.recorrente}
                  onChange={(e: any) => this.obs.recorrente = e.target.checked}
                />
              </div>

              <div style={{ display: "flex" }}>
                <FormGroup label="Gratuito" />
                &nbsp;
                &nbsp;
                <Switch
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  checked={this.obs.gratuito}
                  onChange={(e: any) => this.obs.gratuito = e.target.checked}
                />
              </div>

              <div style={{ width: 300 }}>

                <FormGroup
                  label={this.obs.recorrente ? "Selecione o dia de recorrência" : "Selecione a data"}
                >
                  <DateInput
                    {...getMomentFormatter(this.obs.recorrente ? "DD" : "DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    placeholder={this.obs.recorrente ? "DD" : "DD/MM/AAAA"}
                    onChange={this.handleDateRealizarChange}
                    canClearSelection
                    value={this.obs.data}
                  />
                </FormGroup>
              </div>

              <FormGroup label="Selecione as Empresas:">
                <div className="select-empresa-sefa cnds">
                  <BootstrapTable data={select_empresas} selectRow={selectRowProp} options={options} search>
                    <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataField="razao_social" width="60%">Razão Social</TableHeaderColumn>
                    <TableHeaderColumn dataField="cnpj" width="30%">CNPJ</TableHeaderColumn>
                  </BootstrapTable>
                </div>
              </FormGroup>
            </MDBCol>
          </MDBRow>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateTask()} />
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_buy_chave}
          onClose={() => this.obs.open_buy_chave = false}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Comprar Chaves</h2>

          <FormGroup label="Quantidade">
            <InputGroup
              type="number"
              value={(this.obs.quantidade)}
              onChange={(e) => this.obs.quantidade = e.target.value}
            />
          </FormGroup>

          <FormGroup>
            <label className="bp3-label">Valor de cada Chave</label>
            <IntlCurrencyInput
              className="form-control"
              value={0.88}
              currency="BRL"
              config={currencyConfig}
              disabled
            />
          </FormGroup>

          {this.thisValorCompra()}

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.obs.open_buy_chave = false} />
            <Button text="Confirmar" intent="primary" onClick={() => this.handleBuyChaves()} />
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Cancelar"
          isOpen={this.obs.pagamento_pix}
          onConfirm={() => this.handleCancelPix()}
          className="AlertUser"
          intent="danger"
        >
          <h2 className="titleSEFAZ">Pagar com Pix</h2>

          <div style={{ textAlign: "center" }}>
            <img src={CndsStore.obs.qrcode} width="200" />
            <br />
            <br />
            <h6><b>Total: {numeral(this.obs.valor_total).format("0,0.00")}</b></h6>
            <br />

            <div style={{ display: "inline-flex" }}>
              <h4 className="infoLabel">
                Aguardando Pagamento: {" "}
              </h4>
              &nbsp;&nbsp;
              <div className="lds-ellipsis" style={{ float: "none" }}>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>

        </Alert>

      </>
    )
  }
}

